import { render } from "./productDetailSingleSubOption.vue?vue&type=template&id=2d37b3ff"
import script from "./productDetailSingleSubOption.vue?vue&type=script&lang=js"
export * from "./productDetailSingleSubOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__